import { type RtkQueryLayers } from '../../core';
import { legalsOGService } from './legals.og';

export const legalsRTKSlice: RtkQueryLayers = {
  reducers: {
    [legalsOGService.reducerPath]: legalsOGService.reducer,
  },
  middlewares: [legalsOGService.middleware],
};
